const SGproblemStatements = [
  {
    statementId: "SG1",
    problemStatement:
      "In today’s academic and research landscape, students and researchers often miss valuable scholarships and funding opportunities because information is scattered across platforms. Eligibility criteria are complex, deadlines are hard to track, and there is no single platform that brings everything together. Imagine a unified portal that helps users easily discover, track, and apply for the right scholarships and research grants.",
    exampleFeatures: [
      "Centralized Opportunity Hub: A single platform listing scholarships, fellowships, and research grants.",
      "Advanced Search & Filters: Easily filter by field, education level, funding amount, and location.",
      "Application Tracking Dashboard: Track status of applied scholarships and grants.",
      "Deadline Calendar: Visual calendar with reminders for upcoming deadlines.",
      "Simplified Details View: Clear display of eligibility, benefits, and direct application links."
    ],
    extracontent:
      "Focus on centralized discovery and intelligent matching, not scattered information."
  },
  {
    statementId: "SG2",
    problemStatement:
      "In India, many low-income citizens face legal issues such as labor disputes, domestic conflicts, and tenancy problems but cannot afford legal representation. They are often unaware of free legal aid services provided by organizations. Legal information is complex and difficult to understand, making it challenging for people to access the right help at the right time. Imagine a platform that simplifies legal access guiding users from problem identification to finding the right legal support.",
    exampleFeatures: [
      "Easy Problem Input: Users can describe their legal issue through text or voice in simple language.",
      "Legal Aid Matching: Connects users with nearby legal aid centers, NGOs, or support services.",
      "Appointment Booking: Allows users to schedule consultations with legal experts or organizations.",
      "Simplified Legal Guidance: Provides basic legal advice in easy-to-understand terms.",
      "Multilingual & Voice Support: Ensures accessibility for users from diverse linguistic backgrounds."
    ],
    extracontent:
      "Focus on accessible and understandable legal support, not just information."
  },
  {
    statementId: "SG3",
    problemStatement:
      "In today’s fast-paced urban environment, citizens frequently face issues such as poor road conditions, water supply disruptions, and electricity failures. However, existing complaint systems are often slow, lack transparency, and make it difficult to track progress. Imagine a centralized digital platform where citizens can easily report issues, which are automatically routed to the right authorities, with real-time updates on resolution all in one place.",
    exampleFeatures: [
      "Complaint Submission: Users can submit complaints with geo-tagging, photos, and detailed descriptions.",
      "Auto-Routing System: Complaints are automatically forwarded to the relevant department based on issue type and location.",
      "Real-Time Tracking: Users can track complaint status (pending, in-progress, resolved) in real time.",
      "Escalation Mechanism: Issues are escalated to higher authorities if not resolved within a defined time.",
      "User Profiles: Citizens can view complaint history; officials can manage assigned cases efficiently.",
      "Admin Dashboard: Authorities can monitor complaints, response times, and departmental performance."
    ],
    extracontent:
      "Focus on transparency and accountability in public grievance resolution, not just complaint submission."
  },
  {
    statementId: "SG4",
    problemStatement:
      "In today’s urban environments, public resources like garbage trucks, water tankers, and maintenance teams are often allocated using fixed schedules or manual planning. However, real-world demand varies daily due to factors like population density, weather conditions, and unexpected events, leading to inefficiencies and delays. Imagine a platform that predicts demand and allocates resources dynamically ensuring the right services reach the right place at the right time.",
    exampleFeatures: [
      "Data Input System: Collects area-wise complaint data, population density, and optional weather inputs.",
      "Demand Prediction Engine: Identifies high-demand zones and ranks areas based on urgency.",
      "Interactive Map Dashboard: Visualizes resource allocation and priority heatmaps using map-based UI.",
      "Smart Allocation Suggestions: Provides actionable outputs like resource distribution recommendations.",
      "Real-Time Updates: Continuously adjusts allocation based on incoming data."
    ],
    extracontent:
      "Focus on predictive, real-time resource optimization, not static scheduling."
  }
];

export default SGproblemStatements;